"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeLeft = exports.getBattlePassApi = exports.getChallengesApi = exports.getEventsApi = exports.getAuthApi = void 0;
var api_1 = require("./api");
var configuration_1 = require("./configuration");
function getBaseUrl(service, environment) {
    var envSuffix = '';
    if (environment === 'staging') {
        envSuffix = '-staging';
    }
    else if (environment === 'development') {
        envSuffix = '-dev';
    }
    return "https://" + service + envSuffix + ".scillgame.com";
}
/**
 * Get an instance of the AuthApi class, correctly setup for production environments. Use this class instance to
 * generate access tokens.
 * @summary Get instance of AuthApi
 * @param {string} apiKey The API-Key for your app. You can find your API-Key in the Admin Panel or by using the ApiKeyApi
 * @returns {AuthApi}
 */
function getAuthApi(apiKey, environment) {
    var configuration = new configuration_1.Configuration({
        accessToken: apiKey,
        basePath: getBaseUrl('us', environment)
    });
    return new api_1.AuthApi(configuration);
}
exports.getAuthApi = getAuthApi;
/**
 * Get an instance of the EventsApi class, correctly setup for production environments. Use this class to send events
 * @summary Get instance of EventsApi
 * @param {string} apiKey The API-Key for your app. You can find your API-Key in the Admin Panel or by using the ApiKeyApi
 * @returns {EventsApi}
 */
function getEventsApi(apiKey, environment) {
    var configuration = new configuration_1.Configuration({
        accessToken: apiKey,
        basePath: getBaseUrl('ep', environment)
    });
    return new api_1.EventsApi(configuration);
}
exports.getEventsApi = getEventsApi;
/**
 * Get an instance of the ChallengesApi class, correctly setup for production environments. Use this handle challenges
 * @summary Get instance of ChallengesApi
 * @param {string} accessToken The access token created for the current user using the AuthApi (see generateAccessToken)
 * @returns {ChallengesApi}
 */
function getChallengesApi(accessToken, environment) {
    var configuration = new configuration_1.Configuration({
        accessToken: accessToken,
        basePath: getBaseUrl('pcs', environment)
    });
    return new api_1.ChallengesApi(configuration);
}
exports.getChallengesApi = getChallengesApi;
/**
 * Get an instance of the BattlePassesApi class, correctly setup for production environments. Use this handle battle passes
 * @summary Get instance of BattlePassesApi
 * @param {string} accessToken The access token created for the current user using the AuthApi (see generateAccessToken)
 * @returns {BattlePassesApi}
 */
function getBattlePassApi(accessToken, environment) {
    var configuration = new configuration_1.Configuration({
        accessToken: accessToken,
        basePath: getBaseUrl('es', environment)
    });
    return new api_1.BattlePassesApi(configuration);
}
exports.getBattlePassApi = getBattlePassApi;
function pad(num, size) {
    var number = num.toString();
    while (number.length < size)
        number = "0" + num;
    return number;
}
function timeLeft(challenge) {
    if (challenge.type !== 'in-progress') {
        return null;
    }
    var activateTill = new Date(challenge.user_challenge_activated_at);
    activateTill.setMinutes(activateTill.getMinutes() + challenge.challenge_duration_time);
    var diffMs = (activateTill.getTime() - new Date().getTime()); // milliseconds between now & the challenge ends
    var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
    var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
    var diffSeconds = Math.round((((diffMs % 86400000) % 3600000) / 1000) % 60); // seconds
    return pad(diffHrs, 2) + ":" + pad(diffMins, 2) + ":" + pad(diffSeconds, 2);
}
exports.timeLeft = timeLeft;



//////////////////
// WEBPACK FOOTER
// ./~/@scillgame/scill-js/dist/scillclient.js
// module id = 239
// module chunks = 0